import { createUrl } from '../helpers/createUrl';
import { getPathnameFromHref } from '../helpers/getPathnameFromHref';
import type { ValidHref } from '../types';

export type ExportPickerGetLinkParams =
  /**
   * Export destination picker
   * Chrome-free route embedded by Adobe Boards to pick a Frame.io
   * export-destination folder. /export-picker
   */
  {
    page: 'exportPicker';
  };

export const getLinkForExportPicker = (): ValidHref => {
  return createUrl({ pathname: '/export-picker' });
};

export const isExportPickerPageType = (href: ValidHref): boolean => {
  const pathname = getPathnameFromHref(href);
  const parts = pathname.split('/');
  return parts[1] === 'export-picker';
};
